import { Auth0ApplicationID, Auth0OrganizationID, Auth0OrganizationName, P2P_ORG_NAME } from '@gr/shared/models';
import React, { Dispatch, SetStateAction, useContext } from 'react';
import { Auth0FrontendConfig } from '../providers/auth0-data.provider';
import { getProductAuth0AppId, getProductAuth0OrgId } from '../providers/auth0-product.provider';

export interface Auth0MainConfig {
  clientId: Auth0ApplicationID;
  organization: Auth0OrganizationName;
  organizationId: Auth0OrganizationID;
}

export interface IAuth0ConfigContextContext {
  auth0Config: Auth0FrontendConfig | undefined;
  setAuth0Config: Dispatch<SetStateAction<Auth0FrontendConfig | undefined>>;
}

export const AUTH0_MAIN_CONFIG: Auth0MainConfig = {
  clientId: getProductAuth0AppId(),
  organization: P2P_ORG_NAME,
  organizationId: getProductAuth0OrgId(),
};

const Auth0ConfigContext = React.createContext<IAuth0ConfigContextContext>({
  auth0Config: undefined,
  setAuth0Config: () => { },
});

const Auth0ConfigContextProvider = Auth0ConfigContext.Provider;
const Auth0ConfigContextConsumer = Auth0ConfigContext.Consumer;
const useAuth0Context = () => useContext(Auth0ConfigContext);
export { Auth0ConfigContext, Auth0ConfigContextConsumer, Auth0ConfigContextProvider, useAuth0Context };

